import { initConfig } from "@virtu/config";
import Backend from "./Backend";
import gtm from "./gtm";
import main from "./view/main";

// eslint-disable-next-line no-underscore-dangle
(window as any).__VIRTU_DBG__ = { backend: Backend };

initConfig().then(() => {
    gtm.initialize();
    main.renderApplication();
});
